class VideoBackground extends HTMLElement {
  constructor() {
    super();

    this.videoId = this.dataset.videoId;

    if (document.readyState !== 'loading') {
      this.createScript();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        this.createScript();
      });
    }
  }

  createScript() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    tag.onload = this.setupPlayers.bind(this);
  }

  setupPlayers() {
    let player = null;

    window.YT.ready(() => {
      player = new YT.Player(this, {
        height: '390',
        width: '640',
        videoId: this.videoId,
        playerVars: {
          controls: 0,
          showinfo: 0,
          autohide: 1,
          disablekb: 1,
          loop: 1
        },
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange
        }
      });
    });
  }

  onPlayerReady(event) {
    event.target.mute();
    event.target.playVideo();
  }

  onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.ENDED) {
      event.target.seekTo(0);
      event.target.playVideo();
    }
  }
}

customElements.define('video-background', VideoBackground);